import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TEXTO_CONSENTIMIENTO, VERSION_CONSENTIMIENTO } from '@ausentia/shared';
import { Firma, type FirmaHandle } from '../componentes/Firma.js';
import { useSesion } from '../contexto/Sesion.js';
import { actualizarBorrador, borradorActual, enviarBorrador } from './flujo.js';

export function Consentimiento() {
  const navegar = useNavigate();
  const { medico } = useSesion();
  const b = borradorActual();
  const firmaRef = useRef<FirmaHandle>(null);

  const inicial = b?.consentimientos;
  const [devolucion, setDevolucion] = useState(inicial?.devolucionRecibida ?? true);
  const [error, setError] = useState('');
  const [enviando, setEnviando] = useState(false);

  if (!b || b.resultado !== 'REALIZADA' || !b.evaluacion) {
    return (
      <div className="contenido">
        <p className="muted">No hay un control en curso.</p>
        <button className="primario" onClick={() => navegar('/medico')}>Volver</button>
      </div>
    );
  }
  const ev = b.evaluacion;

  async function confirmar() {
    setError('');
    if (!devolucion) {
      setError('El trabajador debe confirmar que recibió la devolución.');
      return;
    }
    const captura = await firmaRef.current?.capturar();
    if (!captura) {
      setError('Falta la firma del trabajador.');
      return;
    }
    setEnviando(true);
    actualizarBorrador({
      consentimientos: {
        devolucionRecibida: devolucion,
        datosPersonales: true,
        textoVersion: VERSION_CONSENTIMIENTO,
        envio: { email: false, whatsapp: false },
      },
    });
    try {
      const r = await enviarBorrador(medico!, captura);
      if (r.destino === 'firma') navegar('/medico/firma', { state: { codigo: r.codigo, challengeId: r.challengeId, metodo: r.metodoFirma } });
      else if (r.destino === 'acta') navegar('/medico/acta', { state: { codigo: r.codigo } });
      else if (r.destino === 'bloqueada') navegar('/medico/pendientes', { state: { aviso: r.mensaje } });
      else navegar('/medico/pendientes');
    } catch (err) {
      setError(String(err));
      setEnviando(false);
    }
  }

  return (
    <>
      <div className="barra-titulo">
        <button className="volver" onClick={() => navegar(-1)}>‹</button>
        <span>{TEXTO_CONSENTIMIENTO.titulo}</span>
      </div>
      <div className="contenido">
        <div className="tarjeta" style={{ background: 'var(--panel-2)' }}>
          <span className={`insignia ${ev.aptitud === 'APTO_PARA_TRABAJAR' ? 'verde' : 'ambar'}`}>
            {ev.aptitud === 'APTO_PARA_TRABAJAR' ? 'No incapacita para trabajar' : 'Incapacita para trabajar'}
          </span>
        </div>

        <Casilla on={devolucion} set={setDevolucion} texto="Recibí la devolución de la visita médica" />

        <div className="campo" style={{ marginTop: 8 }}>
          <label>Firma del trabajador</label>
          <Firma ref={firmaRef} alto={140} />
          <p className="mini" style={{ textAlign: 'right' }}>
            {b.orden.trabajador.nombreCompleto} · DNI {b.orden.trabajador.dni}
          </p>
        </div>

        <p className="mini">{TEXTO_CONSENTIMIENTO.piePagina}</p>
        {error && <div className="error-box">{error}</div>}
        <button className="primario" onClick={confirmar} disabled={enviando}>
          {enviando ? 'Procesando…' : 'Confirmar firma'}
        </button>
      </div>
    </>
  );
}

function Casilla({
  on,
  set,
  texto,
  detalle,
  opcional,
}: {
  on: boolean;
  set: (v: boolean) => void;
  texto: string;
  detalle?: string;
  opcional?: boolean;
}) {
  return (
    <label
      className={`casilla ${opcional ? 'opcional' : ''}`}
      onClick={() => set(!on)}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          set(!on);
        }
      }}
    >
      <span className={`marca ${on ? 'on' : ''}`}>{on ? '✓' : ''}</span>
      <span style={{ fontSize: 13 }}>
        {texto}
        {detalle && <><br /><span className="mini">{detalle}</span></>}
      </span>
    </label>
  );
}
